import { Dayjs } from "dayjs";
import { FileType } from "../../redux-store/types/api-types";

export enum LoadingKeys {
  GET_SELF_DECLARE = 'GET_SELF_DECLARE',
  SUBBROKER_SELF_DECLARE = 'SUBBROKER_SELF_DECLARE',
}

export enum ProfileDetailsKeys {
  GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS',
}

export enum SubbrokerDeclarationDocType {
  MF = 'SUBBROKER_MF_DECLARATION'
}

export const IS_SELF_DECLARE_SUCCESS = 'IS_SELF_DECLARE_SUCCESS';
export const IS_SELF_DECLARE = 'IS_SELF_DECLARE';

export const GET_SELF_DECLARE_SUCCESS = 'GET_SELF_DECLARE_SUCCESS';
export const GET_SELF_DECLARE = 'GET_SELF_DECLARE';

export const GET_PROFILE_DETAILS_SUCCESS = 'GET_PROFILE_DETAILS_SUCCESS';
export const GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS';

export const GET_SELF_DECLARATION_DOCUMENT_SUCCESS = 'GET_SELF_DECLARATION_DOCUMENT_SUCCESS';
export const GET_SELF_DECLARATION_DOCUMENT = 'GET_SELF_DECLARATION_DOCUMENT';

export const SUBBROKER_GENERATE_OTP_SUCCESS = 'SUBBROKER_GENERATE_OTP_SUCCESS';
export const SUBBROKER_GENERATE_OTP = 'SUBBROKER_GENERATE_OTP';

export const SUBBROKER_VALIDATE_OTP_SUCCESS = 'SUBBROKER_VALIDATE_OTP_SUCCESS';
export const SUBBROKER_VALIDATE_OTP = 'SUBBROKER_VALIDATE_OTP';

export const SUBBROKER_RESEND_OTP_SUCCESS = 'SUBBROKER_RESEND_OTP_SUCCESS';
export const SUBBROKER_RESEND_OTP = 'SUBBROKER_RESEND_OTP';

export const SUBBROKER_REPORT_DOWNLOAD_SUCCESS = 'SUBBROKER_REPORT_DOWNLOAD_SUCCESS';
export const SUBBROKER_REPORT_DOWNLOAD = 'SUBBROKER_REPORT_DOWNLOAD';


export interface initialDocument {
  documentId: string;
  documentType: string;
  documentName: string;
  multipleFiles: string;
  required: string;
  options: string[];
  uploadFormats: string[];
  maxFiles: number;
  maxFileSize: string;
  minFileSize: string;
  disabled?: boolean;
  isActive: boolean;
  uniqueKey: string;
  id?: string | number;
  file?: FileType;
  loading?: boolean;
  expiryDate?: Dayjs | null;
  isThirdPartyFetched?: boolean | null;
  url?: string;
  [key: string]: string | number | boolean | FileType | undefined | string[] | null | boolean | Dayjs;
}

export interface selfReclarationResponseBody {
  isSuccess: boolean;
  message: string;
  data?: selfDeclarationBody[];
}

export interface selfDeclarationRequestBody {
  productDeclaration: selfDeclarationBody[];
}

export interface selfDeclarationBody {
  productType: string;
  isSelfDeclared?: boolean;
  version?: string;
  otpRef?:number
}

export interface getSelfDeclarationResponseBody {
  isSuccess: boolean;
  message: string;
  data: selfDeclarationRes[];
}

export interface selfDeclarationRes {
  productType: string;
  isSelfDeclared: boolean;
  declarationTime: string;
  fy: string;
}

export interface getProfileDetailsResponseBody {
  isSuccess: boolean;
  message: string;
  data: profileDetailsRes;
}

export interface profileDetailsRes {
  name: string;
  mobile: string;
  arnExpiryDate: string;
  countryCode: string;
  countryNameAndCode: string;
  defaultEuin: string;
  defaultEuinValidityDate: string;
  defaultEuinUserId: string;
  email: string;
  euin: string;
  euinValidityDate: string;
  role: string;
  subBrokerARNCode: string;
  userId: string;
  subBrokerARNExpiryDate: string;
  subBrokerARNStartDate: string;

}

export interface selfDeclarationDocumentBody {
  title: string;
  body: string;
  checkBoxText: string;
  version: string;
}

export interface getSelfDeclarationDocumentResponseBody {
  isSuccess: boolean;
  message: string;
  data: selfDeclarationDocumentBody;
}


//SUBBROKER OTP VERIFICATION
export const SUBBROKER_SELF_DECLARATION_FLOW = 'SUBBROKER_SELF_DECLARATION';

export interface SubbrokerGenerateOtpRequestBody {
  flow: string;
}

export interface SubbrokerGenerateOtpResponseBody {
  isSuccess: boolean;
  message: string;
  data: subbrokergenerate[];
}
export interface subbrokergenerate{
    id: number;
    token: string;
    maximum_attemps: string;
    failed_attempts: number;
    message: string;
    numberOfOTPTries: number;
    name?:string;
    isVerified?:boolean;
    userId?:number;
}

export interface SubbrokerValidateOtpRequestBody {
  otp: string;
  token: string;
  id?: number | string;
}

export interface SubbrokerValidateOtpResponseBody {
  isSuccess: boolean;
  message: string;
  data: {
    isSuccess: boolean;
    cancel: boolean;
    id: number;
    token: string;
    message: string;
  };
}

export interface SubbrokerResendOtpRequestBody {
  token: string;
  id?: number | string;
}

export interface SubbrokerResendOtpResponseBody {
  isSuccess: boolean;
  message: string;
  data: {
    isSuccess: boolean;
    id: number;
    token: string;
    maximum_attemps: string;
    failed_attempts: number;
    message: string;
    numberOfOTPTries: number;

  };
}
